<template>
  <div class="row-detail">
    <div class="column-data d-flex" v-for="(prop, index) of Object.keys(expandedData)" :data-id="`row-${index}`" :key="prop">
      <template v-if="columnsHasProp(prop)">
        <div class="column-name p-3">
          <strong>{{ $i18n.t(columnTitle(prop)) }}</strong>
        </div>
        <div class="column-value p-3">
          <field-wrapper :field-name="prop" :row="expandedData" :in-detail-view="true" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'
import FieldWrapper from '../../field-types/FieldWrapper'

export default {
  name: 'DetailView',
  components: { FieldWrapper },
  props: {
    expandedData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    columns() {
      return this.$get('columns')
    },
  },
  methods: {
    columnsHasProp(prop) {
      return this.columns.find((column) => column.data === prop)
    },
    columnTitle(data) {
      return get(
        this.columns.find((column) => column.data === data),
        'title',
        'unknown_column_title',
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.row-detail {
  border: 1px solid $border-color;
  border-radius: $border-radius;
  .column-data {
    display: flex;
    .column-name {
      background-color: $table-header;
      width: 30%;
    }
    .column-value {
      width: 70%;
    }
  }
  .column-data:first-child > .column-name {
    border-top-left-radius: $border-radius;
  }
  .column-data:last-child > .column-name {
    border-bottom-left-radius: $border-radius;
  }
  .column-data:not(:last-child) > * {
    border-bottom: 1px solid $border-color;
  }
}
</style>
